export default function PalletRemovalSection() {
  return (
    <section id="pallet-removal" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/0eec0f6b43802b90423f55e0902fba48/6111e73793c99c3679ea73c47e5a582a.png"
                alt="Pallet Removal Service"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <p className="text-orange-600 text-sm font-bold mb-3 flex items-center">
              <span className="w-2 h-2 bg-orange-600 rounded-full mr-2"></span>
              REMOVAL SERVICE
            </p>
            <h2 className="text-5xl font-serif italic text-gray-900 mb-6">
              Professional Pallet Removal &amp; Recycling
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Need to clear out old, damaged, or excess pallets? Our nationwide pallet removal service provides fast, efficient, and eco-friendly solutions for businesses of all sizes. We handle everything from pickup to proper recycling or disposal.
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-recycle-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Eco-Friendly Recycling</h4>
                  <p className="text-gray-600">
                    We prioritize sustainable practices, recycling usable materials and ensuring proper disposal of damaged pallets to minimize environmental impact.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-timer-flash-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Fast Pickup Service</h4>
                  <p className="text-gray-600">
                    Schedule convenient pickup times that work with your operations. We offer same-day and next-day removal services in most areas nationwide.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Competitive Pricing</h4>
                  <p className="text-gray-600">
                    Get fair pricing for your pallet removal needs. We may even purchase your used pallets if they meet our quality standards.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Nationwide Coverage</h4>
                  <p className="text-gray-600">
                    From small businesses to large warehouses, we provide pallet removal services across all 50 states with reliable logistics.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="bg-orange-600 text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                REQUEST REMOVAL SERVICE
              </a>
              <a
                href="tel:8005557253"
                className="border-2 border-orange-600 text-orange-600 px-8 py-4 rounded-lg text-base font-bold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                CALL NOW
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}